/* eslint-disable */
import { Card, CardContent, Box, Button, InputAdornment } from '@mui/material';
import React from 'react';

import { 
    SavedQueriesList, 
    FilterLiveSearch, 
    FilterList, 
    FilterListItem, 
    Loading,
    useGetList,
    ReferenceInput,
    ReferenceField,
    AutocompleteInput,
    TextField,
    Filter,
    TextInput,
    SelectInput,
 } from 'react-admin';
import MailIcon from '@mui/icons-material/MailOutline';
import CategoryIcon from '@mui/icons-material/LocalOffer';
import SchoolIcon from '@mui/icons-material/School';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import CloseIcon from '@mui/icons-material/Close';
// import CategoryIcon from '@mui/icons-material/Category';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import LayersIcon from '@mui/icons-material/Layers';
import SchemaIcon from '@mui/icons-material/Schema';

export const ModuleFilterSidebar = (props) => {
    return (
        <>
            <Card sx={{ order: -1, mr: 2, mt: 8, width: 300 }}>
                <CardContent>
                    <SavedQueriesList />
                    <ModuleInputFilter/>
                    
                    <FilterList label="Faculty" icon={<SchoolIcon />}>
                        <ModuleFacultyFilter />
                    </FilterList>
                    <FilterList label="Status" icon={<CategoryIcon />} >
                        <ModuleStatusFilter/>
                    </FilterList>
                    <FilterList label="Credit Level" icon={<EqualizerIcon />}>
                        <ModuleLevelFilter/>
                    </FilterList>                    
                    <FilterList label="Is Closed" icon={<CloseIcon />}>
                            <FilterListItem label="No" value={{ isClosed: false }} />                            
                            <FilterListItem label="Yes" value={{ isClosed: true }}  />                            
                    </FilterList>
                    {/* <Button sx={{mt:5}} variant="contained" onClick={submit}>Search</Button> */}
                </CardContent>
            </Card>
        </>
    )
};

const ModuleInputFilter = (props) => (
    <Filter {...props} >
        <TextInput label="Code" source="q" alwaysOn  sx={{width:215}}/>
        <TextInput label="Title" source="shortTitle" alwaysOn  sx={{width:215}}/>
    </Filter>
);
const ModuleStatusFilter = (props) => (
    <Filter {...props} >
        <ReferenceInput reference="Status" source="statusId"  alwaysOn>
            <SelectInput optionText="Title" sx={{width:215}}/>
        </ReferenceInput>
    </Filter>
);

const ModuleFacultyFilter = (props) => (
    <Filter {...props} >
        <ReferenceInput reference="Faculty" source="facultyId" filter={{ isAcademic: true, current: true }} alwaysOn>
            <AutocompleteInput optionText={optionTextFaculty}  sx={{width:215}}/>
        </ReferenceInput>
    </Filter>
);

const ModuleLevelFilter = (props) => (
    <Filter {...props}>
        <ReferenceInput reference="CreditLevel" source="creditLevelId" alwaysOn >
            <AutocompleteInput optionText="description" sx={{width:215}}/>
        </ReferenceInput>
    </Filter>
);

const optionTextFaculty = choice => `${choice.Title}${choice.structureId != '2' ? ' - (Old)' : ''}`;